<template>
  <div class="content">
    <form>
    <oplata-form :datas="dataall"></oplata-form>
    <sklad :datas="dataall"></sklad>
    <paytype :datas="dataall"></paytype>
    <asos :datas="dataall"></asos>
    <kontragent :datas="dataall"></kontragent>
    </form>
    <b-modal id="modal-close" centered>
      <h4>
        {{$t('Sizda saqlanmagan malumotlar mavjud. Saqlansinmi?')}}
      </h4>

      <template #modal-footer="{ ok, cancel, hide }">
        <button type="button" class="btn btn-success" style="margin-bottom: 16px;"
          @click="$root.$refs.oplata.Savedokument()">{{$t('Да')}}</button>
        <button type="button" class="btn btn-danger" @click='Home()'>{{$t('Нет')}}</button>
        <button type="button" class="btn btn-primary" @click="cancel()">{{$t('Отмена')}}</button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { OplataForm, Sklad, Paytype, Asos, Kontragent } from "@/pages";
export default {
  components: { OplataForm, Sklad, Paytype, Asos, Kontragent },
  data() {
    return {
      dataall: {
        datetime: new Date()
          .valueOf()
          .toString()
          .slice(0, 10),
        sklad_id: parseInt(localStorage.getItem("sklad_id")),
        kontragent_id: null,
        user_id: parseInt(localStorage.getItem("user_id")),
        current_total: 0,
        summa: 0,
        pay_type_id: 1,
        current_total_dollar:0,
        dollar_rate:0,
        pay_type_kassa:1,
        kassa_summa:0,
        type: true,
        dollar_summa:0,
        cash_summa:0,
        qaytim_dollar:0,
        qaytim_som:0,
        shot_summa:0,
        plastic_summa:0,
        comment: ""
      }
    };
  },
  created:function(){
    let self=this;
    axios
        .get("api/v1/dollar-exchange-rate/last")
        .then(function(response) {
            self.dataall.dollar_rate=response.data.rate;
            self.$store.state.saved=null;
        });
  },
  methods:{
    Home() {
        this.$store.state.saved = null;
        this.$bvModal.hide('modal-close');
        this.$router.push({ name: "Тўлов" });
      }
  },
  watch: {
    dataall: {
      deep: true,
      handler(val, oldVal) {
        this.$store.state.saved += 1;
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.$store.state.saved < 2) {
      this.$store.state.saved = null;
      next();
    } else {
      this.$bvModal.show("modal-close");
    }
  }
};
</script>
